export default {
    currentUser: null,
    language: '',
    sidebarwidth: 380,
    menu: null,
    lastMenuItemOpen: ''
}